import React from 'react';
import { useStyletron } from 'baseui';
import { CustomColumn, StringColumn, NumericalColumn } from 'baseui/data-table';

import { CustomDateColumn } from 'commons-ui';

export const COL_NAMES = {
	title: 'title',
	subTitle: 'subTitle',
	likes: 'likes',
	shares: 'shares',
	imageUrl: 'imageUrl',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	liveTill: 'liveTill'
};

const isFutureDate = (date: number) => {
	return date > Date.now();
};

export const columnConfigs = [
	CustomColumn({
		title: 'Live Status',
		mapDataToValue: (data: any) => isFutureDate(data[COL_NAMES.liveTill]),
		maxWidth: 100,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? 'YES' : 'NO';
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? 'lightgreen' : 'lightcoral',
						height: '30px',
						width: '100%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Title',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.title].en,
		columnName: COL_NAMES.title
	}),
	StringColumn({
		title: 'SubTitle',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.subTitle].en,
		columnName: COL_NAMES.subTitle
	}),
	NumericalColumn({
		title: 'Likes',
		maxWidth: 200,
		mapDataToValue: (data: any) => data.metaInfo[COL_NAMES.likes],
		columnName: COL_NAMES.likes
	}),
	NumericalColumn({
		title: 'Shares',
		maxWidth: 200,
		mapDataToValue: (data: any) => data.metaInfo[COL_NAMES.shares],
		columnName: COL_NAMES.shares
	}),
	CustomColumn({
		title: 'Title Visible',
		mapDataToValue: (data: any) => data.visibility[COL_NAMES.title],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? 'YES' : 'NO';
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? 'lightgreen' : 'lightcoral',
						height: '30px',
						width: '100%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	CustomColumn({
		title: 'SubTitle Visible',
		mapDataToValue: (data: any) => data.visibility[COL_NAMES.subTitle],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? 'YES' : 'NO';
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? 'lightgreen' : 'lightcoral',
						height: '30px',
						width: '100%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	CustomColumn({
		title: 'Image',
		minWidth: 360,
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.imageUrl][0],
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<a href={value} target='_blank' rel='noreferrer'>
					<img src={value} alt='' className={css({ height: '90px' })} />
				</a>
			);
		}
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	}),
	CustomDateColumn({
		title: 'Live Till',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.liveTill
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
